var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollisionInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_2125_2210)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.936 7.84413L17.0984 11.4639L23.0813 7.55469L23.5993 11.1757C21.2191 11.1812 19.0414 12.6597 18.1932 14.9514L16.8035 18.7062C15.1612 19.2841 13.833 20.6331 13.3433 22.4181L12.1686 26.7002C11.9944 27.3354 11.9398 27.9725 11.9898 28.5888L6.57461 29.2965L8.73237 22.4832L3.58984 17.5202L10.2621 14.9591L10.936 7.84413Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2079 13.2228C22.4272 12.9407 20.6949 13.9548 20.0691 15.6457L18.3054 20.4108C16.8939 20.537 15.6625 21.5246 15.2723 22.9472L14.0976 27.2293C13.7378 28.5409 14.181 29.8667 15.1079 30.712L14.8656 32.2417C14.6887 33.3591 15.451 34.4083 16.5683 34.5853C17.6856 34.7622 18.7349 33.9999 18.9119 32.8826L19.0653 31.9139L34.4743 34.3545L34.3277 35.2806C34.1554 36.3685 34.8976 37.3901 35.9855 37.5625C37.0735 37.7348 38.0951 36.9925 38.2674 35.9046L38.4921 34.4857C39.6958 33.9941 40.5829 32.8399 40.6482 31.4345L40.8543 26.999C40.9199 25.5855 40.1259 24.3136 38.9106 23.7213L38.7039 18.5971C38.6312 16.7956 37.2971 15.2959 35.5163 15.0138L24.2079 13.2228ZM16.5287 25.2685C16.6921 24.2369 17.6608 23.5331 18.6924 23.6965C19.724 23.8599 20.4278 24.8286 20.2644 25.8602C20.1011 26.8918 19.1323 27.5956 18.1007 27.4323C17.0691 27.2689 16.3653 26.3001 16.5287 25.2685ZM37.3719 26.655C36.3403 26.4916 35.3716 27.1955 35.2082 28.2271C35.0448 29.2587 35.7486 30.2274 36.7802 30.3908C37.8118 30.5542 38.7805 29.8504 38.9439 28.8188C39.1073 27.7872 38.4035 26.8184 37.3719 26.655ZM25.405 15.9653C24.1241 15.7624 22.882 16.4676 22.4372 17.6501L21.3142 20.6356C26.2469 21.1228 31.1464 21.9022 35.9868 22.9696L35.8409 19.773C35.7833 18.5109 34.8199 17.4564 33.539 17.2535L25.405 15.9653ZM23.049 24.3865C22.3612 24.2776 21.7154 24.7468 21.6065 25.4345C21.4976 26.1223 21.9668 26.7681 22.6545 26.877L32.6165 28.4548C33.3043 28.5638 33.9501 28.0945 34.059 27.4068C34.168 26.7191 33.6987 26.0733 33.011 25.9643L23.049 24.3865Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2125_2210",
    x1: 1.06167e-7,
    y1: 0.264664,
    x2: 49.2178,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB2CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE3D82"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollisionInsurance);
export default __webpack_public_path__ + "static/media/CollisionInsurance.a195a8853be36fb4fa2509c4d6f8df32.svg";
export { ForwardRef as ReactComponent };